import React, { forwardRef } from 'react';
import { FlowFlag, FlowFlagProps } from './FlowFlag';
import * as Flags from 'country-flag-icons/react/3x2';
import * as SquareFlags from 'country-flag-icons/react/1x1';

export interface FlagProps extends Omit<FlowFlagProps, 'source'> {
  /**
   * Defines which flag to use.
   */
  flag: keyof typeof Flags;
}

/**
 * Renders country flag icon
 * ! usage of component is not recommended as it increases bundle size
 */
export const Flag: React.FC<FlagProps> = forwardRef(({ flag, variant = 'circle', ...rest }, ref) => {
  return (
    <FlowFlag
      source={(['circle', 'square'].includes(variant) ? SquareFlags : Flags)[flag]}
      variant={variant}
      ref={ref}
      {...rest}
    />
  );
});
